/**
 * Миллиметровая сетка холста.
 * Рисуется SVG-паттерном, а не тысячами линий, поэтому не зависит от размера плана.
 * Мелкая сетка (шаг привязки) гаснет при сильном отдалении, чтобы не превращаться в кашу.
 */
import { GRID_MAJOR } from "@/shared/config/units";
import type { ViewBox } from "@/shared/hooks/useViewport";

interface Props {
	box: ViewBox;
	/** Шаг мелкой сетки, мм */
	step: number;
	mmPerPx: number;
}

export const CanvasGrid = ({ box, step, mmPerPx }: Props) => {
	const showMinor = mmPerPx < 12;
	return (
		<>
			<defs>
				<pattern id="grid-minor" width={step} height={step} patternUnits="userSpaceOnUse">
					<path
						d={`M ${step} 0 L 0 0 0 ${step}`}
						fill="none"
						stroke="var(--color-grid-minor)"
						strokeWidth={mmPerPx}
					/>
				</pattern>
				<pattern
					id="grid-major"
					width={GRID_MAJOR}
					height={GRID_MAJOR}
					patternUnits="userSpaceOnUse"
				>
					{showMinor && <rect width={GRID_MAJOR} height={GRID_MAJOR} fill="url(#grid-minor)" />}
					<path
						d={`M ${GRID_MAJOR} 0 L 0 0 0 ${GRID_MAJOR}`}
						fill="none"
						stroke="var(--color-grid-major)"
						strokeWidth={mmPerPx}
					/>
				</pattern>
			</defs>
			<rect x={box.x} y={box.y} width={box.w} height={box.h} fill="url(#grid-major)" />
		</>
	);
};
